import React, {useEffect, useState} from 'react';
import {Col, Row} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import DatePicker from "react-date-picker";
import "react-datepicker/dist/react-datepicker.css";
import {ko} from 'date-fns/esm/locale';
import {
  getGateInfo,
  getRPTInfo,
  postRptDevice,
  postRptDeviceDelete,
  putRptDevice
} from "../../api/apiClient";
import ModalCtrl from "./ModalCtrl";
import Swal from "sweetalert2";
import Moment from "moment";


const RptPopupBody = ({
                        propFcltyNm,
                        propFcltyCd,
                        propFloorNm,
                        propFloorNo,
                        propID,
                        propIsNew = true,
                        propX = 0,
                        propY = 0,
                        hClose,
                      }) => {

  const [stRpt, setRpt] = useState({
    // 시설명
    // fclty_dtl_no: 0,
    // // 층수
    // //fcltyDtlNo: 0,
    // // 장비id
    // rpeatId: 0,
    // // 중계기 일련번호
    // rpeatSn: 0,
    // // 장비제조사
    // mkr: 0,
    // //장비모델명
    // modl: 0,
    // // 장비(위치)
    // fcltyLcNm: 0,
    // //설치일자
    //instlDe: '2000-01-01',
    // // 게이트웨이 관리
    // gtwyNo: 0,
    x_crdnt: propX,
    y_crdnt: propY,
  });
  const [stInstlDe, setInstlde] = useState();

  const onChange = (e, id) => {
    // console.log('onchange')
    let val = e.target.value;
    // console.log(val);
    // console.log(id);
    onChangeValue(val, id);
  }

  const onChangeValue = (val, id) => {
    let stTemp = stRpt;

    // console.log(stTemp)
    stTemp[id] = val;
    setRpt(stTemp);
  }

  const onChangeDate = (date) => {
    // let year = date.getFullYear();
    // let month = date.getMonth() + 1;
    // let day = date.getDate();
    // let timeString = `${year}-${month}-${day}`;
    setRpt({...stRpt, instl_de: date});
  };

  const onDelete = (e) => {
    Swal.fire({
      title: `삭제하시겠습니까?`,
      text: `중계기(${propID})를 삭제합니다.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '확인',
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        postRptDeviceDelete(propID).then(
            (res => {
              Swal.fire(
                  '삭제되었습니다!',
                  '',
                  'success'
              );
              hClose(true);
            })
        );
      }
    })
  }

  const onSubmit = (e) => {
    e.preventDefault();
    if (propFcltyNm === undefined) {
      Swal.fire('시설명은 필수 항목입니다.', '', 'error');
      return;
    }
    if (propFloorNm === undefined) {
      Swal.fire('층수는 필수 항목입니다.', '', 'error');
      return;
    }

    if (stRpt.rpeat_id === undefined) {
      Swal.fire('장비 ID는 필수 항목입니다.', '', 'error');
      return;
    }

    if (stRpt.rpeat_lc_nm === undefined) {
      Swal.fire('장비명(위치)는 필수 항목입니다.', '', 'error');
      return;
    }


    if (propIsNew) {
      if (isValid()) {
        postRptDevice(stRpt)
            .then(res => {
              if (res.data.status === 200) {
                Swal.fire(
                    '정상적으로 처리 되었습니다!',
                    '',
                    'success'
                )
              }
            })
            .catch(err => {
              Swal.fire(
                  err.response.data.message,
                  '',
                  'error'
              );
            });
        hClose(true);
      } else {
        Swal.fire('필수 입력 항목이 누락되었습니다.');
      }
    } else {
      putRptDevice(stRpt)
          .then(res => {
            if (res.data.status === 200) {
              Swal.fire(
                  '수정되었습니다.',
                  '',
                  'success'
              );
            }
          })
          .catch(err => {
            Swal.fire(
                err.response.data.message,
                '',
                'error'
            );
          });
      hClose(true);
    }
  };


// control ////////////////////////////////////
  const [stCtlShow, setCtlShow] = useState(false);
  const onControl = () => {
    if (stRpt.rpeat_id === "") {
      Swal.fire("장비 등록을 먼저 하세요.");
      return;
    }
    setCtlShow(true);
  };

  const isValid = () => {
    if (stRpt.rpeat_id === undefined) {
      return false;
    }
    // if (stRpt.mkr === undefined) {
    //   return false;
    // }
    // if (stRpt.modl === undefined) {
    //   return false;
    // }
    if (stRpt.rpeat_lc_nm === undefined) {
      return false;
    }
    // if (stRpt.instl_de === undefined) {
    //   return false;
    // }

    return true;
  }


  useEffect(() => {
    if (propIsNew === false) {
      // get
      getRPTInfo(propID)
          .then(res => {
            setRpt(res.data.data);
          })
    } else {
      getGateInfo(propFcltyCd)
          .then(res => {
            setRpt({
              fclty_dtl_no: propFloorNo,
              fclty_dtl_nm: propFloorNm,
              gtwy_no: res.data.data.list[0].cd,
              rpeat_sn: 0,
              x_crdnt: propX,
              y_crdnt: propY
            });
          });

    }
  }, []);

  useEffect(() => {
    console.log(stRpt)
    if (stRpt.instl_de !== undefined) {
      setInstlde(new Date(stRpt.instl_de));
    }
  }, [stRpt]);

  return (
      <Container fluid className={"layer p-2"}>
        <ModalCtrl
            propShow={stCtlShow}
            propDevice={stRpt.rpeat_id}
            propType={'2'}
            setShow={setCtlShow}
        />
        <Row className={""}>
          <Col className={''}>
            <Row className={'info-container py-2 mx-3'}>
              <Col md={11} className={'px-5'}>
                <div className={'content-container-body-item'}>
                  <Form
                      className={'gateway-register-form py-3'}
                      id={'gatewayRegisterForm'}
                  >
                    <Row className={"justify-content-center"}>
                      <Col md={12}>
                        <Row>
                          <Col md={12}>
                            <Form.Group as={Row} controlId="formGtwyId">
                              <Form.Label column md={3} className={'label text-end fw-bold'}>
                                <span className={"text-danger"}>* </span>시설명
                              </Form.Label>
                              <Col md={9} className={''}>
                                <Form.Control
                                    type='text'
                                    className={'input text-white'}
                                    readOnly={true}
                                    defaultValue={propFcltyNm}
                                />
                              </Col>
                            </Form.Group>
                          </Col>

                          <Col md={12}>
                            <Form.Group as={Row} controlId='formIp1Addr'>
                              <Form.Label column md={3} className={'label text-end fw-bold'}>
                                <span className={"text-danger"}>* </span>층수
                              </Form.Label>
                              <Col md={9} className={''}>
                                <Form.Control
                                    type='text'
                                    className={'input text-white'}
                                    readOnly={true}
                                    defaultValue={stRpt.fclty_dtl_nm || ''}
                                />
                              </Col>
                            </Form.Group>
                          </Col>

                          <Col md={12}>
                            <Form.Group as={Row} controlId='formIp2Addr'>
                              <Form.Label column md={3} className={'label text-end fw-bold'}>
                                <span className={"text-danger"}>* </span>장비 ID
                              </Form.Label>
                              <Col md={9}>
                                <Form.Control
                                    type='text'
                                    className={'input text-white'}
                                    defaultValue={stRpt.rpeat_id || ''}
                                    // value={stRpt.rpeat_id || ''}
                                    onChange={(e) => {
                                      onChange(e, 'rpeat_id');
                                    }}
                                />
                              </Col>
                            </Form.Group>
                          </Col>

                          <Col md={12}>
                            <Form.Group as={Row} controlId='forml2IpAddr'>
                              <Form.Label column md={3} className={'label text-end'}>
                                장비시리얼 ID
                              </Form.Label>
                              <Col md={9}>
                                <Form.Control
                                    type='text'
                                    className={'input text-white'}
                                    defaultValue={stRpt.sid || ''}
                                    // value={stRpt.sid || ''}
                                    onChange={(e) => {
                                      onChange(e, 'sid');
                                    }}
                                />
                              </Col>
                            </Form.Group>
                          </Col>

                          <Col md={12}>
                            <Form.Group as={Row} controlId='forml2IpAddr'>
                              <Form.Label column md={3} className={'label text-end'}>
                                제조사
                              </Form.Label>
                              <Col md={9}>
                                <Form.Control
                                    type='text'
                                    className={'input text-white'}
                                    defaultValue={stRpt.mkr || ''}
                                    // value={stRpt.mkr || ''}
                                    onChange={(e) => {
                                      onChange(e, 'mkr');
                                    }}
                                />
                              </Col>
                            </Form.Group>
                          </Col>

                          <Col md={12}>
                            <Form.Group as={Row} controlId='forml2IpAddr'>
                              <Form.Label column md={3} className={'label text-end'}>
                                모델
                              </Form.Label>
                              <Col md={9}>
                                <Form.Control
                                    type='text'
                                    className={'input text-white'}
                                    defaultValue={stRpt.modl || ''}
                                    // value={stRpt.modl || ''}
                                    onChange={(e) => {
                                      onChange(e, 'modl');
                                    }}
                                />
                              </Col>
                            </Form.Group>
                          </Col>

                          <Col md={12}>
                            <Form.Group as={Row} controlId='formFcltyNm'>
                              <Form.Label column md={3} className={'label  text-end fw-bold'}>
                                <span className={"text-danger"}>* </span>장비명 (실명)
                              </Form.Label>
                              <Col md={9} className={''}>
                                <Form.Control
                                    type='text'
                                    className={'input text-white'}
                                    defaultValue={stRpt.rpeat_lc_nm || ''}
                                    // value={stRpt.rpeat_lc_nm || ''}
                                    onChange={(e) => {
                                      onChange(e, 'rpeat_lc_nm');
                                    }}
                                />
                              </Col>
                            </Form.Group>
                          </Col>

                          <Col md={12}>
                            <Form.Group as={Row} controlId="formBasicSelectMenu"
                                        className={"justify-content-end"}>
                              <Form.Label column sm={3} className={"label text-end"}>
                                설치일자
                              </Form.Label>
                              <Col sm={9}>
                                <DatePicker
                                    onChange={(date) => {
                                      onChangeDate(Moment(date).format('YYYY-MM-DD'));
                                    }}
                                    value={stRpt.instl_de ? new Date(stRpt.instl_de) : ''}
                                    format={"yyyy-MM-dd"}
                                    clearIcon={null}
                                    className={"datepicker-start w-100 text-center"}
                                    calendarType={'US'}
                                    formatDay={
                                      (locale, date) => new Intl.DateTimeFormat(
                                          'en-US',
                                          {
                                            day: "numeric"
                                          }).format(date)
                                    }
                                />
                              </Col>
                            </Form.Group>
                          </Col>

                        </Row>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </Col>
            </Row>
            <Row className={"my-3 justify-content-center"}>
              {propIsNew === false ?
                  <Col md={2} className={'justify-content-center'}>
                    <Button className={'btn btn-danger w-100'}
                            onClick={onDelete}>삭제</Button>
                  </Col> : ''
              }

              <Col md={2} className={'justify-content-center'}>
                <Button className={'btn btn-secondary w-100'}
                        onClick={hClose}>취소</Button>
              </Col>
              <Col md={2} className={'justify-content-center'}>
                <Button className={'btn save-btn w-100'}
                        onClick={onSubmit}>저장</Button>
              </Col>
              {propIsNew === false ?
                  <Col md={2} className={'justify-content-center'}>
                    <Button className={'btn w-100'} variant={"success"}
                            onClick={onControl}>제어</Button>
                  </Col> : ''}
            </Row>
          </Col>

        </Row>
      </Container>
  );
};

export default RptPopupBody;
